// @core/api/endpoints/secret/decrypt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DecryptRequest,
  DecryptResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Decrypt data
 * Decrypts ciphertext using the named key. Returns base64-encoded plaintext. Supports batch decryption.
 */
export async function Decrypt(
  engine_id: string,
  key_name: string,
  data: DecryptRequest,
  options?: RequestOptions
): Promise<DecryptResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/decrypt/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<DecryptResponse>(requestPath, data, requestOptions);
}
